/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Scroll = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4" }],
    ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4" }]
  ]
];

export { Scroll as default };
//# sourceMappingURL=scroll.js.map
